
/**
 *
 * @param {Blob} blob
 * @param {import('./web-api').FileDownloadOptions} options
 * @param {Pick<Window, 'URL'|'document'>} [window]
 */
export const downloadBlobAsFile = (blob, options, { URL, document } = window) => {
    const { filename } = options;

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.setAttribute('download', filename);
    link.setAttribute('href', url);
    link.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    link.remove();
};
